import React, { HTMLAttributes} from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { cn } from '../../lib/utils'
import { useQuery } from '@tanstack/react-query'
import axios from '../../lib/axios';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
    eventid?: number;
    departmentid?: number;
    partnerid?: number;
    pronoid?: number;
    view?: 'partner' | 'event' | 'department' | 'prono' | 'groups'
}

const SmallRankingsTable : React.FC<Props & HTMLAttributes<HTMLDivElement>> = ({eventid, departmentid, partnerid, pronoid, view='partner', className}) => {
    const {auth} = useAuth()
    const {t} = useTranslation()
    const { data:ranking, isFetching:isFetchingRanking } = useQuery<EventRanking[] | null>({
        queryKey: [`ranking_${eventid}_${pronoid}_${departmentid}_${view}`],
        queryFn: async () => {
            try {
                const partnerURL = partnerid ? `&partnerid=${partnerid}` : ''
                const departURL = departmentid ? `&departmentid=${departmentid}` : ''
                const eventURL = eventid ? `&eventid=${eventid}` : ''
                const pronoURL = pronoid ? `&pronoid=${pronoid}` : ''

                let url = partnerURL + departURL + eventURL + pronoURL

                if(view === 'groups') {
                    url += `&type=depts`
                }

                const {data} = await axios.get(`ranking?${url}`)
                let res = data;

                if(!Array.isArray(res)){return null}
                return res
            } catch (error) {
                return null
            }
        },
        enabled: !!eventid || !!departmentid || !!partnerid || !!pronoid
    })

  return (
    <Table className={cn('border-separate border-spacing-y-2', className)}>
        <TableHeader>
            <TableRow className='border-none hover:bg-transparent'>
                <TableHead className='w-12 h-6 font-normal text-white'>{t("ranking.pos")}</TableHead>
                <TableHead className='h-6 font-normal text-white'>{t("ranking.name")}</TableHead>
                <TableHead className='h-6 font-normal text-right text-white'>{t("ranking.pts")}</TableHead>
            </TableRow>
        </TableHeader>
        <TableBody>
            {ranking && ranking.slice(0,5).sort((a,b)=>b.m_iPoints-a.m_iPoints).map((rank, index)=>{
                return (
                <TableRow className={`${rank.m_iUserID === auth.data.m_iUserID ? 'text-tifo-light' : 'text-white'} bg-white/10 hover:bg-white/20`} key={index}>
                    <TableCell className='py-3 overflow-hidden rounded-l-sm'>{index+1}</TableCell>
                    <TableCell className='py-3'>
                        {view === 'groups'
                        ? <>{rank.m_sDepartment}</>
                        : <>{rank.m_sUser} {rank.m_iUserID === auth.data.m_iUserID && ` (${t("ranking.you")}) `}</>}
                    </TableCell>
                    <TableCell className='py-3 text-right rounded-r-sm'>
                        {view === 'groups' 
                        ? rank.m_nDeptAvgPoints
                        : rank.m_iPoints
                        }
                    </TableCell>
                </TableRow>
                )
            })}
            {ranking && ranking.find(i=>i.m_iUserID === auth.data.m_iUserID) && ranking.findIndex(i=>i.m_iUserID === auth.data.m_iUserID) > 4 && 
            <TableRow className='text-tifo-light bg-white/10 hover:bg-white/20'>
                <TableCell className='py-3 overflow-hidden rounded-l-sm'>{ranking.findIndex(i=>i.m_iUserID === auth.data.m_iUserID)+1}</TableCell>
                <TableCell className='py-3'>
                    {view === 'groups'
                    ? <></>
                    : <>{auth.data.m_sFirstName} ({t("ranking.you")})</>}
                </TableCell>
                <TableCell className='py-3 text-right rounded-r-sm'>{ranking.find(i=>i.m_iUserID === auth.data.m_iUserID)?.m_iPoints}</TableCell>
            </TableRow>
            }

            {ranking && 
            <TableRow className='text-white bg-transparent hover:bg-transparent'>
                <TableCell colSpan={99}>
                    <div className='flex items-center justify-center'>
                        <Link to="/klassementen" className='text-center underline uppercase text-tifo-light'>{t("event.more")}</Link>
                    </div>
                </TableCell>
            </TableRow>
            }

            {(!ranking && !isFetchingRanking) && <TableRow className='text-white bg-white/10'><TableCell colSpan={3}>{t("ranking.no_ranking_title")}...</TableCell></TableRow>}
        </TableBody>
    </Table>
  )
}

export default SmallRankingsTable